"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GET_USER_ATTRIBUTES_QUERY = "\n  query GetUserAttributes {\n    user {\n      attributes {\n        name\n        value\n      }\n    }\n  }\n";
exports.default = GET_USER_ATTRIBUTES_QUERY;
//# sourceMappingURL=getUserAttributes.js.map